import { defineNuxtRouteMiddleware, navigateTo } from '#app';

export default defineNuxtRouteMiddleware(to => {
  if (to.path === '/blog/kak-lechit-parodontoz-v-domashnikh-usloviyakh-i-narodnymi-sredstvami/') {
    return navigateTo('/services/', { redirectCode: 301 });
  }
});
